export default __webpack_public_path__ + "static/media/ic_practice.95d68af0ca82e1dd313ce0d11fe8a24e.svg";